/* eslint-disable no-unreachable */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import api from '../../../services/api';
import { getPermissions } from '../../../services/auth';
import { dataAtualFormatada, dddTel, slugify } from '../../../utils/functions';
import RegisterRender from './RegisterRender';
import { encrypt } from '../../../services/crypto';

function Register() {
  const [inputs, setInputs] = useState({
    status: 'Pendente',
    perfilId: 0,
    login: '',
    senha: '',
    podeConsultarAntecipacoesPesquisaGrid: true,
    podeConsultarEmailsInteresse: true,
    podeConsultarFornecedoresAnotacoesGrid: true,
    podeConsultarFrequenciaAntecipacaoAgendado: true,
    podeConsultarFrequenciaAntecipacaoDe1a30: true,
    podeConsultarFrequenciaAntecipacaoDe31a90: true,
    podeConsultarFrequenciaAntecipacaoMaior90: true,
    podeConsultarFrequenciaAntecipacaoNuncaAntecipou: true,
    podeConsultarFrequenciaAntecipacaoTodos: true,
  });
  const [getLoading, setLoading] = useState(true);

  const [getEstados, setEstados] = useState([]);
  const [getMunicipios, setMunicipios] = useState([]);
  const [getJornadas, setJornadas] = useState([]);
  const [getPerfis, setPerfis] = useState([]);
  const [getErros, setErros] = useState([]);
  const [inputsBlocked, setInputsBlocked] = useState([]);

  const [getEstadosLoading, setEstadosLoading] = useState(false);
  const [getMunicipiosLoading, setMunicipiosLoading] = useState(false);

  const history = useHistory();

  const handleInputChange = (event, value) => {
    event.persist();

    if (event.target.value === 'AjudaDeCusto') {
      confirmAlert({
        title: 'Informação',
        message:
          'Obrigatório colher assinatura no termo de Opção de Desistência do Vale Transporte',
        buttons: [
          {
            label: 'Ok',
          },
        ],
      });
    }
    setInputs((inputs) => ({
      ...inputs,
      [event.target.name]: value || slugify(event.target.value),
    }));
  };

  const handleInputCheckboxChange = (event, value) => {
    event.persist();
    setInputs((inputs) => ({
      ...inputs,
      [event.target.name]: value,
    }));
  };

  const findCep = async (cep) => {
    cep = cep.replace('-', '').replace('.', '');
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json`);
      const { logradouro, bairro, ibge } = response.data;

      if (logradouro.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'logradouro']);
      }
      if (bairro.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'bairro']);
      }

      if (ibge.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'estado', 'municipio']);
        const responseMunicipio = await api.get(`Municipios/ConsultarIBGEId?id=${ibge}`);
        const { estadoId, municipioId } = responseMunicipio.data.resposta[0];
        setInputs({ ...inputs, logradouro, bairro, estadoId, municipioId });

        const listFields = ['Cep', 'Logradouro', 'Bairro', 'EstadoId', 'MunicipioId'];

        setErros(
          getErros.filter(function (item) {
            return !listFields.includes(item);
          }),
        );
      } else {
        setInputs({ ...inputs, logradouro, bairro });
      }
    } catch (err) {
      setInputsBlocked([]);
    }
  };

  const getInfoForForm = async () => {
    try {
      const searchJornadas = await api.get('JornadasTrabalhos/Consultar?status=Ativo');
      const searchProfiles = await api.get('Perfis/Consultar?status=Ativo');
      const searchStates = await api.get('Estados/Consultar?status=Ativo');

      setEstados(searchStates.data.resposta);
      setJornadas(searchJornadas.data.resposta);
      setPerfis(searchProfiles.data.resposta);
    } catch (err) {
      toast.error('Detectamos um problema interno! tente novamente em instantes.');
    }
    setLoading(false);
  };

  const getAllMunicipios = async () => {
    setMunicipiosLoading(true);
    try {
      const searchCities = await api.get(
        `Municipios/ConsultarEstadoId?id=${inputs.estadoId}&status=Ativo`,
      );
      setMunicipios(searchCities.data.resposta);
      setInputs({ ...inputs, municipioId: inputs.municipioId });
    } catch (err) {
      toast.error('Falha ao consultar a lista de municípios');
    }
    setMunicipiosLoading(false);
  };

  const getAllEstados = async () => {
    setEstadosLoading(true);
    try {
      const searchStates = await api.get('Estados/Consultar?status=Ativo');
      setEstados(searchStates.data.resposta);
    } catch (err) {
      toast.error('Falha ao consultar a lista de estados');
    }
    setEstadosLoading(false);
  };

  useEffect(() => {
    const permissions = getPermissions({ moduloId: 1344, permissao: 'Cadastrar' });

    if (permissions) {
      getInfoForForm();
    } else {
      history.push('/app');
    }
  }, []);

  useEffect(() => {
    if (inputs.estadoId) {
      getAllMunicipios();
    }
  }, [inputs.estadoId]);

  const formatSalario = (salario) => {
    if(typeof salario === 'string') {
      salario = salario.replace('.', '').replace(',', '.')
    }
    return Number(salario)
  }

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();
      setLoading(true);

      try {
        const response = await api.post('Colaboradores', {
          ...inputs,
          senha: encrypt(inputs.senha),
          numero: inputs.numero && parseInt(inputs.numero),
          estadoId: inputs.estadoId && parseInt(inputs.estadoId),
          municipioId: inputs.municipioId && parseInt(inputs.municipioId),
          ctpsNumero: inputs.ctpsNumero && parseInt(inputs.ctpsNumero),
          salarioFamilia:
            inputs.qtdFilhosMenor14Anos && parseInt(inputs.qtdFilhosMenor14Anos) === 0
              ? 'Nao'
              : inputs.salarioFamilia,
          qtdFilhosMenor14Anos:
            inputs.qtdFilhosMenor14Anos && parseInt(inputs.qtdFilhosMenor14Anos),
          jornadaTrabalhoId: inputs.jornadaTrabalhoId && parseInt(inputs.jornadaTrabalhoId),
          perfilId: inputs.perfilId && parseInt(inputs.perfilId),
          ddd1: inputs.telefone1 && dddTel(inputs.telefone1, 'ddd'),
          ddd2: inputs.telefone2 && dddTel(inputs.telefone2, 'ddd'),
          telefone1: inputs.telefone1 && dddTel(inputs.telefone1),
          telefone2: inputs.telefone2 && dddTel(inputs.telefone2),
          dataAdmissao: inputs.dataAdmissao && dataAtualFormatada(inputs.dataAdmissao),
          dataNascimento: inputs.dataNascimento && dataAtualFormatada(inputs.dataNascimento),
          valorSalario: inputs.valorSalario ? formatSalario(inputs.valorSalario) : 0,
          podeConsultarAntecipacoesPesquisaGrid: inputs.podeConsultarAntecipacoesPesquisaGrid ? true : false,
          podeConsultarEmailsInteresse: inputs.podeConsultarEmailsInteresse ? true : false,
          podeConsultarFornecedoresAnotacoesGrid: inputs.podeConsultarFornecedoresAnotacoesGrid ? true : false,
          podeConsultarFrequenciaAntecipacaoAgendado: inputs.podeConsultarFrequenciaAntecipacaoAgendado ? true : false,
          podeConsultarFrequenciaAntecipacaoDe1a30: inputs.podeConsultarFrequenciaAntecipacaoDe1a30 ? true : false,
          podeConsultarFrequenciaAntecipacaoDe31a90: inputs.podeConsultarFrequenciaAntecipacaoDe31a90 ? true : false,
          podeConsultarFrequenciaAntecipacaoMaior90: inputs.podeConsultarFrequenciaAntecipacaoMaior90 ? true : false,
          podeConsultarFrequenciaAntecipacaoNuncaAntecipou: inputs.podeConsultarFrequenciaAntecipacaoNuncaAntecipou ? true : false,
          podeConsultarFrequenciaAntecipacaoTodos: inputs.podeConsultarFrequenciaAntecipacaoTodos ? true : false,
        });
        if (response.data.status !== 'Inconsistencia') {
          setInputs({});
          toast.success('Colaborador registrado com sucesso!');
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = [];

            response.data.resposta.map((resposta) => {
              errosArray.push(resposta.key);
              toast.error(resposta.key + ' - ' + resposta.message);
              return null;
            });
            setErros(errosArray);
          } else {
            toast.error('Não foi possível adicionar o novo colaborador!');
          }
        }
      } catch (err) {
        toast.error('Não foi possível adicionar o novo colaborador!');
      }
      setLoading(false);
    }
  };

  return (
    <RegisterRender
      inputs={inputs}
      handleInputChange={handleInputChange}
      handleInputCheckboxChange={handleInputCheckboxChange}
      getLoading={getLoading}
      getEstados={getEstados}
      getMunicipios={getMunicipios}
      getJornadas={getJornadas}
      getPerfis={getPerfis}
      getAllMunicipios={getAllMunicipios}
      getAllEstados={getAllEstados}
      getEstadosLoading={getEstadosLoading}
      getMunicipiosLoading={getMunicipiosLoading}
      onSubmit={handleSubmit}
      getErros={getErros}
      setErros={setErros}
      findCep={findCep}
      inputsBlocked={inputsBlocked}
    />
  );
}

export default Register;
